<template>
  <keep-alive include="orderList">
    <router-view ></router-view>
  </keep-alive>
</template>

<script>
  export default {
    name: "Message",
    created() {
      if (!this.common.loginInfo.isLogin){
        this.$router.push("/login")
      }
    }
  }
</script>

<style scoped>

</style>
